import { parseUrl } from 'query-string';
import { getLanguageId } from './globals';
export function getBaseUrl() {
    return `/${getLanguageId()}`;
}
export function getArticlePath({ slug, languageId = getLanguageId(), }) {
    return `/${languageId}/articles/${slug}`;
}
export function getCategoryPath({ slug, languageId = getLanguageId(), }) {
    return `/${languageId}/categories/${slug}`;
}
export function getHomePath({ languageId = getLanguageId(), }) {
    return `/${languageId}`;
}
export function getExtraPagePath({ languageId = getLanguageId(), path, }) {
    return `/${languageId}/${path}`;
}
export function getSearchPagePath({ languageId = getLanguageId(), } = {}) {
    return `/${languageId}/search`;
}
export function getCurrentSearchQuery() {
    const parsedUrl = parseUrl(location.search);
    const query = parsedUrl.query['query'] || '';
    return query;
}
export function getSsoUrl() {
    return '/sso/login';
}
export function getAgentLoginUrl() {
    return '/sso/agent/login';
}
//# sourceMappingURL=routes.js.map